/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetConnectRssIcon64Regular = forwardRef('NetConnectRssIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M27.424 14.45a38.002 38.002 0 0 0-15.817-2.375 1.5 1.5 0 1 1-.189-2.994A41 41 0 0 1 54.92 52.56a1.5 1.5 0 1 1-2.994-.187A37.999 37.999 0 0 0 27.424 14.45Z" }),
        React.createElement("path", { d: "M21.329 29.257a22 22 0 0 0-9.667-1.132 1.5 1.5 0 0 1-.319-2.983 24.998 24.998 0 0 1 27.514 27.53 1.5 1.5 0 1 1-2.983-.32 22 22 0 0 0-14.545-23.095Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 42a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm-3 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z" })));
});
